import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import GetCustomers                                 from "../../../application/usecase/customer/GetCustomers";
import Customers                                    from "../../../domain/customer/Customers";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import RightPositionSection                         from "../../components/common/layout/RightPositionSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import OfficeSelector                               from "../../components/common/OfficeSelector";
import CustomerCsvExportButton                      from "../../components/customer/CustomerCsvExportButton";
import CustomerList                                 from "../../components/customer/CustomerList";
import CustomerNewButton                            from "../../components/customer/CustomerNewButton";
import CustomersSearchBox                           from "../../components/customer/CustomersSearchBox";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

interface Props extends BaseProps {
  customers: Customers;
  getCustomers: GetCustomers;
}

class CustomersContainer extends ResKaBaseContainer<Props, BaseState> {
  constructor(props: Props) {
    const state = {
      headerTitle: "顧客一覧",
      menuType: MenuType.CUSTOMER,
    };

    super(props, state);
  }

  protected componentDidMountInternal(): void {
    const {customers} = this.props;
    this.props.getCustomers.execute(customers.pagination.current, customers.search, customers.sortType);
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <RightPositionSection>
          <OfficeSelector/>
        </RightPositionSection>

        <TopSection>
          <CustomerNewButton/>
        </TopSection>

        <TopSection>
          <CustomersSearchBox/>
          <CustomerCsvExportButton/>
        </TopSection>

        <CustomerList/>
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
  customers: state.customers,
});
const mapDispatchToProps = (dispatch) => ({
  getCustomers: new GetCustomers(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomersContainer);
